import { __decorate } from "tslib";
import { property, query, state } from 'lit/decorators.js';
import { css, html, LitElement } from 'lit';
import 'altcha';
import { get } from 'lit-translate';
import '../../../atom/paragraph/element';
export class Captcha extends LitElement {
    constructor() {
        super(...arguments);
        this.api = 'captcha';
        this.name = 'captcha';
        this.translation = {};
        this.auto = true;
        this.debug = false;
        this.test = false;
        this.translationStrings = '';
        this.onVerified = (e) => {
            dispatchEvent(new CustomEvent('verified', { detail: e.detail }));
        };
        this.onStateChanged = (e) => {
            dispatchEvent(new CustomEvent('statechanged', { detail: e.detail }));
        };
        this.toggleErrorMessage = (force = undefined) => {
            this.errorMsg.classList.toggle('hidden', force);
        };
    }
    render() {
        return html `
            <div>
                <altcha-widget
                    challengeurl="${this.api}"
                    name="${this.name}"
                    strings="${this.translationStrings}"
                    ?auto="${this.auto}"
                    ?debug="${this.debug}"
                    ?test="${this.test}"
                ></altcha-widget>
                <ep-p class="error-msg hidden">
                    <slot></slot>
                </ep-p>
            </div>
        `;
    }
    firstUpdated(_changedProperties) {
        this.translationStrings = JSON.stringify({
            label: get('storybook.captcha.label'),
            verified: get('storybook.captcha.verified'),
            verifying: get('storybook.captcha.verifying'),
            waitAlert: get('storybook.captcha.waitAlert'),
            error: get('storybook.captcha.error'),
            expired: get('storybook.captcha.expired'),
            ...this.translation
        });
        super.firstUpdated(_changedProperties);
        setTimeout(() => {
            this.altchaWidget.addEventListener('statechange', (ev) => {
                // detail.state: unverified, verifying, verified, error
                this.onStateChanged(ev);
                if (ev.detail.state === 'verified') {
                    this.toggleErrorMessage(true);
                    this.onVerified(ev);
                }
            });
        }, 100);
    }
}
Captcha.styles = css `
        :host {
            display: block;
        }

        altcha-widget {
            --altcha-border-width: var(--ep-captcha-border-width, 2px);
            --altcha-border-radius: var(--ep-captcha-border-radius, 3px);
            --altcha-color-border: var(--ep-captcha-border-color, var(--ep-color-tertiary));
            --altcha-color-base: var(--ep-color-white);
            --altcha-color-text: var(--ep-text-color);
            --altcha-color-error-text: var(--ep-color-danger);

            font-family: var(--ep-text-font-family);
        }

        ep-p {
            padding: var(--ep-form-msg-padding, 4px 0 0 2px);
            --ep-text-color: var(--ep-color-danger);
        }

        .hidden {
            display: none;
        }
    `;
__decorate([
    property({ type: String })
], Captcha.prototype, "api", void 0);
__decorate([
    property({ type: String })
], Captcha.prototype, "name", void 0);
__decorate([
    property({ type: Object })
], Captcha.prototype, "translation", void 0);
__decorate([
    property({ type: Boolean })
], Captcha.prototype, "auto", void 0);
__decorate([
    property({ type: Boolean })
], Captcha.prototype, "debug", void 0);
__decorate([
    property({ type: Boolean })
], Captcha.prototype, "test", void 0);
__decorate([
    state()
], Captcha.prototype, "translationStrings", void 0);
__decorate([
    query('altcha-widget')
], Captcha.prototype, "altchaWidget", void 0);
__decorate([
    query('.error-msg')
], Captcha.prototype, "errorMsg", void 0);
__decorate([
    property({ type: Function })
], Captcha.prototype, "onVerified", void 0);
__decorate([
    property({ type: Function })
], Captcha.prototype, "onStateChanged", void 0);
__decorate([
    property({ type: Function })
], Captcha.prototype, "toggleErrorMessage", void 0);
if (!customElements.get('ep-form-captcha')) {
    customElements.define('ep-form-captcha', Captcha);
}
//# sourceMappingURL=element.js.map